/**
 * Absolute scan URLs built from the current environment origin so a printed
 * label resolves to prod / staging / localhost depending on where it was made.
 */
const origin = (): string => window.location.origin;

export const lotScanUrl = (id: string): string => `${origin()}/inventory/lots/${id}`;
export const workOrderScanUrl = (id: string): string => `${origin()}/work-orders/${id}/view`;
export const finishedGoodScanUrl = (id: string): string => `${origin()}/inventory/finished-goods/${id}/view`;
